import { getTransition } from 'styles/useTransition';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';

interface Props {
	color?: string;
	size?: number;
	lineHeight?: number;
	opened?: boolean;
	curentStepName?: string;
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const StyledLine = styled.div<Props>`
	position: absolute;
	width: ${({ size }) => size ?? 24}px;
	height: ${({ lineHeight }) => lineHeight ?? 3}px;
	background-color: ${({ theme, color }) => color ?? theme.colors.primary};
	border-radius: 1.5px;
	${({ theme }) => getTransition(theme.durations.ms200, ['top', 'transform', 'opacity', 'filter'])};
`;

const StyledLine1 = styled(StyledLine)`
	top: ${({ opened }) => (opened ? '50%' : '5px')};
	transform: rotate(${({ opened }) => (opened ? 45 : 0)}deg);
`;

const StyledLine2 = styled(StyledLine)`
	top: ${({ size, lineHeight }) => (size && lineHeight ? (size - 3 * lineHeight) / 2 : 11)}px;
	opacity: ${({ opened }) => (opened ? 0 : 1)};
`;

const StyledLine3 = styled(StyledLine)`
	top: ${({ size, lineHeight, opened }) =>
		opened ? '50%' : size && lineHeight ? size - 3 * lineHeight : 17}px;
	transform: rotate(${({ opened }) => (opened ? -45 : 0)}deg);
`;

const StyledButton = styled.button<Props>`
	cursor: pointer;
	border: 0;
	position: relative;
	z-index: 1;
	background: none;
	width: ${({ size }) => size ?? 24}px;
	height: ${({ size }) => size ?? 24}px;

	&:active,
	&:focus,
	&:not(:active):hover {
		div {
			filter: brightness(1.3);
		}
	}

	${({ curentStepName }) =>
		(curentStepName === 'age_bb' || curentStepName === 'start_pilates_age') &&
		css<Props>`
			visibility: hidden;
			pointer-events: none;
		`}
`;

export const MenuButton: FC<Props> = props => {
	const { onClick, size, color, lineHeight, curentStepName, opened } = props;

	const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
		onClick?.(e);
	};

	return (
		<StyledButton size={size} onClick={handleClick} curentStepName={curentStepName}>
			<StyledLine1 opened={opened} size={size} color={color} lineHeight={lineHeight} />
			<StyledLine2 opened={opened} size={size} color={color} lineHeight={lineHeight} />
			<StyledLine3 opened={opened} size={size} color={color} lineHeight={lineHeight} />
		</StyledButton>
	);
};
